import { loc } from "../i18n/survey";

enum HeightUnit {
  Feet = "ft",
  Centimeters = "cm",
}

const heightToggle = {
  name: "heightUnit",
  titleLocation: "hidden",
  type: "boolean",
  labelTrue: HeightUnit.Centimeters,
  valueTrue: HeightUnit.Centimeters,
  labelFalse: HeightUnit.Feet,
  valueFalse: HeightUnit.Feet,
  defaultValue: HeightUnit.Feet,
};

const heightInputTemplate = {
  type: "text",
  inputType: "number",
  titleLocation: "left",
};

const heightRaw = {
  ...heightInputTemplate,
  name: "heightRaw",
  isRequired: true,
  title: "{heightUnit}",
  placeholder: loc("quiz.height.placeholderFeet"),
  visibleIf: `{heightUnit} = ${HeightUnit.Feet}`,
  validators: [
    {
      type: "numeric",
      minValue: 3,
      maxValue: 300,
      text: loc("quiz.height.invalidUnit"),
    },
  ],
};

const heightRawCm = {
  ...heightInputTemplate,
  name: "heightRaw",
  isRequired: true,
  title: "{heightUnit}",
  placeholder: loc("quiz.height.placeholderCm"),
  visibleIf: `{heightUnit} = ${HeightUnit.Centimeters}`,
  validators: [
    {
      type: "numeric",
      minValue: 3,
      maxValue: 300,
      text: loc("quiz.height.invalidUnit"),
    },
  ],
};

const heightInches = {
  ...heightInputTemplate,
  name: "heightInches",
  startWithNewLine: true,
  visibleIf: `{heightUnit} = ${HeightUnit.Feet}`,
  title: "in",
  placeholder: loc("quiz.height.placeholderInches"),
  validators: [
    {
      type: "numeric",
      minValue: 0,
      maxValue: 12,
      text: loc("quiz.height.invalidInches"),
    },
  ],
};

const heightQuestion = {
  type: "multipletext",
  name: "height",
  title: loc("quiz.height.title"),
  description: loc("quiz.height.description"),
  elements: [],
};

export {
  heightInches,
  heightQuestion,
  heightRaw,
  heightRawCm,
  heightToggle,
  HeightUnit,
};
